import { render, staticRenderFns } from "./Social.vue?vue&type=template&id=2a28adea&scoped=true&"
import script from "./Social.vue?vue&type=script&lang=js&"
export * from "./Social.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a28adea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a28adea')) {
      api.createRecord('2a28adea', component.options)
    } else {
      api.reload('2a28adea', component.options)
    }
    module.hot.accept("./Social.vue?vue&type=template&id=2a28adea&scoped=true&", function () {
      api.rerender('2a28adea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Setting/Social.vue"
export default component.exports